import { jsx as _jsx } from "react/jsx-runtime";
import Stack from '@mui/material/Stack';
import { Spinner } from './spinner';
/**
 * CenteredSpinner component that wraps the Spinner in a centered container
 * Useful for displaying a loading indicator centered in its parent container
 *
 * @param props - The component props (same as Spinner props)
 * @returns A spinner component centered in its container
 *
 * @example
 * ```tsx
 * <CenteredSpinner aria-label={i18next.t("react.mf.feedback_spinner.src.translations.json.loadingContent")} />
 * ```
 */
export const CenteredSpinner = (props) => {
    return (_jsx(Stack, { height: "100%", width: "100%", justifyContent: "center", alignItems: "center", children: _jsx(Spinner, { ...props }) }));
};
